import React, { useState } from 'react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { AlertTriangle, X, Eye, Clock } from 'lucide-react'
import { useImpersonation } from '@/contexts/ImpersonationContext'

export default function ImpersonationBanner() {
  const { isImpersonating, impersonationSession, endImpersonation, timeRemaining } = useImpersonation()
  const [isMinimized, setIsMinimized] = useState(false)

  if (!isImpersonating || !impersonationSession) {
    return null
  }

  // Minimized state - just a small badge
  if (isMinimized) {
    return (
      <div className="fixed top-4 right-4 z-50">
        <Badge
          variant="destructive"
          className="cursor-pointer hover:scale-105 transition-transform px-4 py-2"
          onClick={() => setIsMinimized(false)}
        >
          <Eye className="h-3 w-3 mr-2" />
          Impersonating {impersonationSession.target_church_name}
        </Badge>
      </div>
    )
  }

  return (
    <div className="sticky top-0 z-50 border-b-4 border-destructive">
      <Alert variant="destructive" className="rounded-none border-0">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <AlertTriangle className="h-5 w-5" />
            <div>
              <div className="font-semibold flex items-center gap-2">
                <Eye className="h-4 w-4" />
                Impersonation Mode Active
              </div>
              <AlertDescription className="mt-1">
                You are viewing the platform as <strong>{impersonationSession.target_church_name}</strong>
              </AlertDescription>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {/* Time Remaining */}
            <div className="flex items-center gap-2 text-sm">
              <Clock className="h-4 w-4" />
              <span className="font-medium">
                {timeRemaining > 0 ? `${timeRemaining} min remaining` : 'Expired'}
              </span>
            </div>

            {/* Minimize Button */}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsMinimized(true)}
              className="h-8 hover:bg-destructive-foreground/10"
            >
              <X className="h-4 w-4" />
            </Button>

            {/* End Impersonation Button */}
            <Button
              variant="outline"
              size="sm"
              onClick={endImpersonation}
              className="bg-background hover:bg-accent"
            >
              End Impersonation
            </Button>
          </div>
        </div>
      </Alert>
    </div>
  )
}
